/* eslint-disable no-unused-vars */
import { Chip, Tooltip } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { GlobalContext } from "../../../utils/GlobalContext";
import CalenderImg from "../../Assets/Img/calender.svg";
import LocationImg from "../../Assets/Img/Location.png";
import DummyImg from "../../Assets/Img/Rectangle 21.png";
import NoCamp from "../../Assets/Img/amico.svg";
import create from "../../Assets/Img/create dashboard.png";
import instagram from "../../Assets/Img/instagram.png";
import Search from "../../Assets/Img/search.png";
import youtube from "../../Assets/Img/youtube.png";
import youtubeDeliverables from "../../Assets/Img/youtube deliverables.svg";
import instaDeliverables from "../../Assets/Img/insta deliverables.svg";
import { SearchBar } from "../../Common/Components/SearchBar";
import Track from "../../DummyContacts.js/Track";
import axiosMain from "../../http/axiosMain";
import { Calendar } from "lucide-react";

export default function InsightsHome({ id }) {
  const { userData } = useContext(GlobalContext);
  const [currentStep, setCurrentStep] = useState(1);
  const [dataList, setDataList] = useState([]);
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showContent, setShowContent] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState(data);
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("ongoing");
  const debounceTimeoutRef = useRef(null);
  const plan_type = localStorage.getItem("PlanType");

 useEffect(() => {
  fetchData(activeTab); 
}, [activeTab]);

  const [contentTypes, setContentTypes] = useState([
    {
      platform: "Instagram",
      items: [
        { id: "reels", label: "Reels", count: 1, checked: false },
        { id: "posts", label: "Posts", count: 1, checked: false },
        { id: "story", label: "Story", count: 1, checked: false },
      ],
    },
    {
      platform: "YouTube",
      items: [
        { id: "shorts", label: "Shorts", count: 1, checked: false },
        { id: "video", label: "Video", count: 1, checked: false },
        { id: "liveStream", label: "Live Stream", count: 1, checked: false },
      ],
    },
  ]);

  const handleCheckboxChange = (platformIndex, itemIndex) => {
    const newContentTypes = [...contentTypes];
    newContentTypes[platformIndex].items[itemIndex].checked =
      !newContentTypes[platformIndex].items[itemIndex].checked;
    setContentTypes(newContentTypes);
  };

  const handleNextbtn = () => {
    if (currentStep < totalSteps) {
      setCurrentStep((prevStep) => prevStep + 1);
    }
  };

  const handlePrevbtn = () => {
    if (currentStep > 1) {
      setCurrentStep((prevStep) => prevStep - 1);
    }
  };
  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
    setEndDate(""); // Reset end date when start date changes
    setShowContent(false);
  };
  const formatSingleDate = (dateString) => {
    if (!dateString) return ""; // Handle empty or invalid dates
    const date = new Date(dateString);

    // Ensure valid date
    if (isNaN(date.getTime())) return "";

    const day = date.getUTCDate(); 
    const month = date.toLocaleString("default", { month: "short" }); 
    const suffix = getDaySuffix(day); 

    return `${day}${suffix} ${month}`;
  };

  const getDaySuffix = (day) => {
    if (day >= 11 && day <= 13) return "th"; 
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
    setLoading(true);
    setShowContent(false);

    setTimeout(() => {
      setLoading(false);
      setShowContent(true);
    }, 2000); 
  };

  const currentDate = new Date().toISOString().split("T")[0];

  const totalSteps = 4;

  const handleNext = () => {
    setCurrentStep((prev) => Math.min(prev + 1, totalSteps));
  };

  const handlePrev = () => {
    setCurrentStep((prev) => Math.max(prev - 1, 1));
  };
  const [selectedAge, setSelectedAge] = useState(null);

  const handleAgeSelect = (age) => {
    setSelectedAge(age);
  };

  const handleSaveDraft = () => {
    // Log save draft response here
    // console.log("Draft Saved:", {
    //   startDate,
    //   endDate,
    //   contentTypes,
    //   selectedAge,
    // });
  };

  const handlePublish = () => {
    // console.log("Campaign Published:", {
    //   startDate,
    //   endDate,
    //   contentTypes,
    //   selectedAge,
    // });
  };
  const ViewDetails = (id) => {
    navigate(`/insightsDeliverables/${id}`);
  };

  const navigate = useNavigate();

  const fetchData = async (status = null, title = null) => {
    setLoading(true);
    setError(null);
    setSearchQuery("");
    try {
      const response = await axiosMain.get("/api/v1/campaigns", {
        params: {
          ...(status && { campaign_status: status }),
          ...(title && { campaign_title: title }),
        },
      });
      setDataList(response.data.campaigns);
    } catch (err) {
      console.error("Fetch error:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(activeTab); // initial fetch or when tab changes
  }, [activeTab]);

  useEffect(() => {
    fetchData(activeTab);
  }, [activeTab]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500">
          Loading...
        </div>
      </div>
    );
  }
  const today = new Date().toLocaleDateString("en-CA"); // YYYY-MM-DD in local time

  const recentCampaigns = data?.filter(
    (ele) => ele.camping_created_date.split("T")[0] === today
  );

  const handleSearch = (query) => {
    // const query = e.target.value;
    setSearchQuery(query);

    // Clear previous timeout if still waiting
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }

    // Set new debounce timeout
    debounceTimeoutRef.current = setTimeout(() => {
      performSearch(query);
    }, 2000); // 2 seconds
  };

  const performSearch = async (query) => {
    try {
      if (query?.trim().length > 0) {
        setLoading(true);
        const response = await axiosMain.get("/api/v1/campaigns", {
          params: { campaign_title: query },
        });
        setDataList(response.data.campaigns);
      } else {
        fetchData(); // Fetch all if input is empty
      }
    } catch (err) {
      console.error("Search error:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {plan_type === "Starter" ? (
        <>
          <Track />
        </>
      ) : (
        <div className="campaignCreate">
          <div className="SearchFilterSection">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="d-flex justify-content-between align-items-center w-100 py-1">
                    {/* Left side: Completed Campaign text */}
                    <div>
                      <h5 className="mb-0 fw-semibold">Completed Campaign</h5>
                    </div>

                    {/* Right side: Search Bar (only if data exists) */}
                    {dataList?.length > 0 && (
                      <div className="d-flex align-items-center">
                        <SearchBar
                          searchQuery={searchQuery}
                          setSearchQuery={handleSearch}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="CreatedCampaigns mt-1">
            <div className="row mt-1 g-4 overflow-auto vh-75 pe-2">
              {" "}
              {/* Add Bootstrap classes */}
              {dataList.length > 0 ? (
                dataList?.map((ele) => {
                  // Parse the timeline data for Instagram and YouTube content
                  let timeline = [];
                  try {
                    timeline = JSON.parse(ele.timeline || "[]");
                  } catch (err) {
                    console.error(
                      "Invalid JSON in timeline:",
                      ele.timeline,
                      err
                    );
                  }
                  // Check if Instagram content has more than 0
                  const instagramContent = timeline.some(
                    (entry) =>
                      entry.Instagram?.reels > 0 ||
                      entry.Instagram?.posts > 0 ||
                      entry.Instagram?.story > 0
                  );

                  // Check if YouTube content has more than 0
                  const youtubeContent = timeline.some(
                    (entry) =>
                      entry.YouTube?.shorts > 0 ||
                      entry.YouTube?.videos > 0 ||
                      entry.YouTube?.live_stream > 0
                  );
                  const cities = Array.isArray(ele.city)
                    ? ele.city
                    : typeof ele.city === "string"
                    ? [ele.city]
                    : [];

                  const states = Array.isArray(ele.state)
                    ? ele.state
                    : typeof ele.state === "string"
                    ? [ele.state]
                    : [];

                  // Combine city and state
                  const locations = cities.map((city, index) => ({
                    city,
                    state: states[index] || "", // Ensure state exists
                  }));

                  return (
                    <div
                      key={ele.campaign_id}
                      className="col-xl-3 col-lg-4 col-md-6"
                    >
                      <div className="campaign-card">
                        <div className="influencer-home-image">
                          <img
                            src={ele.campaign_poster || DummyImg}
                            alt={ele.campaign_title}
                            className="campaign-image w-100"
                          />
                        </div>

                        <div className="p-3">
                          <div className="d-flex justify-content-between align-items-start mb-2">
                            <div className="StatusCamp">
                              <Tooltip
                                title={
                                  ele?.campaign_title
                                    ?.charAt(0)
                                    ?.toUpperCase() +
                                  ele?.campaign_title?.slice(1)
                                }
                              >
                                <h5 className="mb-1 campaign-title">
                                  {ele?.campaign_title
                                    ?.charAt(0)
                                    ?.toUpperCase() +
                                    ele?.campaign_title?.slice(1)}
                                </h5>
                              </Tooltip>
                              <span
                                className={`status-badge status-${ele?.campaign_status
                                  ?.toLowerCase()
                                  .replace(/\s+/g, "-")}`}
                              >
                                {ele?.campaign_status}
                              </span>
                            </div>
                          </div>
                          <p className="mb-2">{ele.campaign_obj}</p>
                          <div className="d-flex align-items-center mb-2">
                            <span className="date-text text-black">
                              <Calendar
                                color="rgba(101, 101, 101, 1)"
                                size={15}
                              />
                              {formatSingleDate(ele.start_date)} -{" "}
                              {formatSingleDate(ele.end_date)}
                            </span>
                          </div>
                          <hr />
                          <div className="mb-3">
                            <div className="influencer-home-product">
                              Product Name
                            </div>
                            <div className="text-black">
                              {ele.product_name || "-"}
                            </div>
                          </div>
                          <div className="mb-3">
                            <div className="influencer-home-product">
                              Budget
                            </div>
                            <div className="text-black fw-medium">
                              {ele.budget || "-"}
                            </div>
                          </div>
                          <div className="mb-3">
                            <div className="influencer-home-product">
                              Deliverables
                            </div>
                            <div>
                              <div className="d-flex">
                                {(() => {
                                  const firstWeek =
                                    ele.timeline && ele.timeline.length > 0
                                      ? ele.timeline[0]
                                      : null;

                                  const hasInstagramContent =
                                    firstWeek &&
                                    firstWeek.Instagram &&
                                    (firstWeek.Instagram.reels > 0 ||
                                      firstWeek.Instagram.posts > 0 ||
                                      firstWeek.Instagram.story > 0);

                                  const hasYouTubeContent =
                                    firstWeek &&
                                    firstWeek.YouTube &&
                                    (firstWeek.YouTube.shorts > 0 ||
                                      firstWeek.YouTube.videos > 0 ||
                                      firstWeek.YouTube.live_stream > 0);

                                  return (
                                    <>
                                      {hasInstagramContent && (
                                        <div className="campaign-image-container me-3">
                                          <img
                                            src={instaDeliverables}
                                            alt="Instagram"
                                            className="social-media-icon-campaign"
                                          />
                                        </div>
                                      )}

                                      {hasYouTubeContent && (
                                        <div className="campaign-image-container">
                                          <img
                                            src={youtubeDeliverables}
                                            alt="YouTube"
                                            className="social-media-icon-campaign"
                                          />
                                        </div>
                                      )}
                                    </>
                                  );
                                })()}
                              </div>
                            </div>
                          </div>
                        </div>
                        <button onClick={() => ViewDetails(ele.campaign_id)}>
                          Add Deliverables Link
                        </button>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
                  <div className="text-center px-4 max-w-md mx-auto">
                    <div>
                      <img
                        src={NoCamp}
                        alt="No Campaigns"
                        className="img-fluid"
                      />
                    </div>
                    {userData?.role === "brand" ? (
                      <>
                        <h2 className="fw-bold">Welcome to the Campaign!</h2>
                        <p className="text-muted mb-4">
                          It looks like you haven't created any campaigns yet.
                          Ready to launch your first one?
                        </p>
                      </>
                    ) : userData?.role === "influencer" ? (
                      <>
                        <p className="text-muted mb-4">
                          No Collaboration Request sent or accepted.
                        </p>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
